import React from 'react';
import GamificationDashboard from './GamificationDashboard';

const Gamification = () => {
  return <GamificationDashboard />;
};

export default Gamification;